import { getBookkeepingAccounts } from '../../api/admin';
import invalidationManager from './InvalidationManager';
import BookkeepingAccount from '../../model/BookkeepingAccount';

const { hook: useBookkeepingAccounts } = invalidationManager.createFetcher({
  queryKey: (companyId: string) => ['company', companyId, 'bookkeepingAccounts'],
  fetchFunction: async (companyId: string): Promise<BookkeepingAccount[]> => {
    return getBookkeepingAccounts(companyId);
  },
});

export { useBookkeepingAccounts };
